interface AttachmentShape {id:string;mime:string;}
interface StickerMessage {kind:string;body:string;attachments?:readonly AttachmentShape[];entities?:readonly unknown[];}

export function isStickerAttachment(attachment:AttachmentShape,entities:readonly unknown[]|undefined):boolean {
  return attachment.mime==='image/webp' && Boolean(entities?.some(entity=>entity!==null && typeof entity==='object'
    && 'type' in entity && entity.type==='sticker' && 'attachment_id' in entity && entity.attachment_id===attachment.id));
}

export function isStickerOnlyMessage(message:StickerMessage):boolean {
  return message.kind==='user' && !message.body.trim() && Boolean(message.attachments?.length)
    && message.attachments!.every(attachment=>isStickerAttachment(attachment,message.entities));
}

/** Keep the existing direct rows and memoized articles. Only the first row of an
 * author group owns a rail; separators and ungrouped rows bound its containing
 * block. Run on mount/resize, never on scroll. All geometry reads precede writes. */
export function syncMessageAvatarRails(history:HTMLElement):void {
  const groups:{first:HTMLElement;last:HTMLElement;rail:HTMLElement}[]=[];
  let group:typeof groups[number]|undefined;
  for(const child of history.children){
    if(!(child instanceof HTMLElement)||!child.classList.contains('message-row')){group=undefined;continue;}
    const rail=child.querySelector<HTMLElement>(':scope > .message-avatar-rail');
    if(rail){group={first:child,last:child,rail};groups.push(group);}
    else if(child.classList.contains('grouped')&&group)group.last=child;
    else group=undefined;
  }
  const sizes=groups.map(({first,last,rail})=>({rail,height:Math.max(32,last.offsetTop+last.offsetHeight-first.offsetTop)}));
  for(const {rail,height} of sizes){const value=`${height}px`;if(rail.style.height!==value)rail.style.height=value;}
}
